import type { SortOrder } from '@core/Areas/Account/Pages/Activity/types'
import { RootState } from '@core/Store'

export function getPendingSortOrder(state: RootState): SortOrder {
  return state.accountActivity.pendingSortOrder
}

export function getResultsSortOrder(state: RootState): SortOrder {
  return state.accountActivity.resultsSortOrder
}
